module.exports = __webpack_public_path__ + "static/media/featured-complement.1ef93003.svg";